/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Strength_DietInputs */

const en_portal_goal_strength_diet = /** @type {(inputs: Portal_Goal_Strength_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories for heavy and light days`)
};

const pl_portal_goal_strength_diet = /** @type {(inputs: Portal_Goal_Strength_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorie pod dni ciężkie i lekkie`)
};

/**
* | output |
* | --- |
* | "Calories for heavy and light days" |
*
* @param {Portal_Goal_Strength_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_strength_diet = /** @type {((inputs?: Portal_Goal_Strength_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Strength_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_strength_diet(inputs)
	return en_portal_goal_strength_diet(inputs)
});